import { useState } from "react";
import { Element } from "react-scroll";
import Hero from "./Hero/Hero";
import Calculator from "./Calculator/Calculator";
import Journey from "./Journey/Journey";
import MidCta from "./MidCta/MidCta";
import Eligibility from "./Eligibility/Eligibility";
import Testimonials from "./Testimonials/Testimonials";
import LearnMore from "./LearnMore/LearnMore";

const HowItWorksV2 = (): JSX.Element => {
  const [step1OpenFaq, setStep1OpenFaq] = useState<number | undefined>(undefined);

  return (
    <div className="bg-white">
      <Hero />
      <Element name="calculator">
        <Calculator />
      </Element>
      <div className="relative">
        <Journey step1OpenFaq={step1OpenFaq} setStep1OpenFaq={setStep1OpenFaq} />
      </div>
      <div className="py-4">
        <MidCta />
      </div>
      <Eligibility />
      <Testimonials />
      <LearnMore />
    </div>
  );
};

export default HowItWorksV2;
